window.FabricSamplesRenderer = (() => {
  const ICONS = {
    plus: '<svg width="16" height="16" viewBox="0 0 16 16" fill="#202020" xmlns="http://www.w3.org/2000/svg"><path d="M7.99992 3.33337V12.6667M3.33325 8.00004H12.6666" stroke="#202020" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    check: '<svg width="16" height="16" viewBox="0 0 16 16" fill="transparent" xmlns="http://www.w3.org/2000/svg"><path d="M13.3334 4L6.00008 11.3333L2.66675 8" stroke="#202020" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    maximize: '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.33333 2H3.33333C2.97971 2 2.64057 2.14048 2.39052 2.39052C2.14048 2.64057 2 2.97971 2 3.33333V5.33333M14 5.33333V3.33333C14 2.97971 13.8595 2.64057 13.6095 2.39052C13.3594 2.14048 13.0203 2 12.6667 2H10.6667M10.6667 14H12.6667C13.0203 14 13.3594 13.8595 13.6095 13.6095C13.8595 13.3594 14 13.0203 14 12.6667V10.6667M2 10.6667V12.6667C2 13.0203 2.14048 13.3594 2.39052 13.6095C2.64057 13.8595 2.97971 14 3.33333 14H5.33333" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    zoom: '<svg width="35" height="35" viewBox="0 0 35 35" fill="none" xmlns="http://www.w3.org/2000/svg"><rect width="35" height="35" rx="17.5" fill="#202020" fill-opacity="0.5"/><path d="M16.6027 23.3989C20.5301 23.3989 23.7139 20.2152 23.7139 16.2878C23.7139 12.3604 20.5301 9.17664 16.6027 9.17664C12.6753 9.17664 9.49158 12.3604 9.49158 16.2878C9.49158 20.2152 12.6753 23.3989 16.6027 23.3989Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M25.4916 25.1766L21.6249 21.3099" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M16.612 13.0912V19.3134" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M13.5009 16.2023H19.7231" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    lessThan: '<svg width="45" height="24" viewBox="0 0 21 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15 6L9 12L15 18" stroke="#202020" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    greaterThan: '<svg width="45" height="24" viewBox="0 0 21 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 18L12 12L6 6" stroke="#202020" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    collapsiblePlus: '<svg class="collapsible-plus" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path opacity="0.8" d="M6.33341 1.33337V10.6667M1.66675 6.00004H11.0001" stroke="#202020" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
    collapsibleMinus: '<svg class="collapsible-minus" width="12" height="2" viewBox="0 0 12 2" fill="none" xmlns="http://www.w3.org/2000/svg"><path opacity="0.8" d="M1.66675 1H11.0001" stroke="#202020" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
  };

  let data = null;
  let allProducts = null;
  let productMap = new Map();
  let productIdMap = new Map();
  let blockProductMap = new Map();
  let activeSort = "default";

  let _onFullLoad = null;
  let _onMasterReady = null;

  function getSortByFromUrl(urlLike) {
    try {
      const url = new URL(urlLike || window.location.href, window.location.origin);
      return url.searchParams.get("sort_by") || "default";
    } catch (error) {
      return "default";
    }
  }

  function sortProducts(products, sortBy) {
    if (!Array.isArray(products) || products.length < 2) return products || [];

    const sorted = [...products];

    switch (sortBy) {
      case "title-ascending":
        sorted.sort((a, b) =>
          String(a.title || "").localeCompare(String(b.title || ""), undefined, {
            numeric: true,
            sensitivity: "base",
          }),
        );
        break;
      case "title-descending":
        sorted.sort((a, b) =>
          String(b.title || "").localeCompare(String(a.title || ""), undefined, {
            numeric: true,
            sensitivity: "base",
          }),
        );
        break;
      case "price-ascending":
        sorted.sort((a, b) => Number(a.price || 0) - Number(b.price || 0));
        break;
      case "price-descending":
        sorted.sort((a, b) => Number(b.price || 0) - Number(a.price || 0));
        break;
      case "created-descending":
        sorted.sort(
          (a, b) =>
            new Date(b.createdAt || 0).getTime() -
            new Date(a.createdAt || 0).getTime(),
        );
        break;
      default:
        break;
    }

    return sorted;
  }

  async function init(jsonEl) {
    data = JSON.parse(jsonEl.textContent);
    activeSort = getSortByFromUrl(window.location.href);

    buildMaps();
    groupProductsByBlock();
    renderGrid();
    buildFabricSamplesData();

    if (data.pagination.totalPages > 1) {
      const gridContainer = document.querySelector(".fabric-samples-container");
      if (gridContainer) gridContainer.classList.add("is-loading");

      fetchRemainingPages()
        .then(() => {
          buildMaps();
          groupProductsByBlock();
          renderGrid();
          buildFabricSamplesData();

          if (!data.hasActiveFilters) {
            allProducts = [...data.products];
          } else {
            bootstrapMasterDataset();
          }

          if (_onFullLoad) _onFullLoad();
        })
        .catch(() => {
          bootstrapMasterDataset();
        })
        .finally(() => {
          if (gridContainer) gridContainer.classList.remove("is-loading");
        });
    } else {
      if (!data.hasActiveFilters) {
        allProducts = [...data.products];
      } else {
        bootstrapMasterDataset();
      }
    }

    return data;
  }

  function onFullLoad(cb) {
    _onFullLoad = cb;
  }

  async function initFromData(newData, baseUrl) {
    data = newData;
    activeSort = getSortByFromUrl(baseUrl || window.location.href);

    if (data.pagination.totalPages > 1 && baseUrl) {
      await fetchRemainingPages(baseUrl);
    }

    buildMaps();
    groupProductsByBlock();
    renderGrid();
    buildFabricSamplesData();
    return data;
  }

  async function fetchRemainingPages(baseUrl) {
    const sectionId = data.sectionId;
    const fetches = [];
    for (let page = 2; page <= data.pagination.totalPages; page++) {
      const url = new URL(baseUrl || window.location.href, window.location.origin);
      url.searchParams.set("page", page);
      if (sectionId) url.searchParams.set("sections", sectionId);

      fetches.push(
        (sectionId
          ? fetch(url.toString()).then((r) => r.json()).then((s) =>
              new DOMParser().parseFromString(s[sectionId], "text/html"))
          : fetch(url.toString()).then((r) => r.text()).then((html) =>
              new DOMParser().parseFromString(html, "text/html"))
        ).then((doc) => {
          const el = doc.getElementById("fabric-samples-data");
          return el ? JSON.parse(el.textContent).products : [];
        }),
      );
    }
    const results = await Promise.all(fetches);
    results.forEach((products) => data.products.push(...products));
  }

  function fetchSectionDoc(url) {
    const sectionId = data.sectionId;
    if (sectionId) url.searchParams.set("sections", sectionId);
    return sectionId
      ? fetch(url.toString()).then((r) => r.json()).then((s) =>
          new DOMParser().parseFromString(s[sectionId], "text/html"))
      : fetch(url.toString()).then((r) => r.text()).then((html) =>
          new DOMParser().parseFromString(html, "text/html"));
  }

  async function bootstrapMasterDataset() {
    try {
      const url = new URL(window.location.href, window.location.origin);
      for (const key of [...url.searchParams.keys()]) {
        if (key.startsWith("filter.")) url.searchParams.delete(key);
      }
      url.searchParams.delete("sort_by");
      url.searchParams.set("page", 1);

      const doc = await fetchSectionDoc(url);
      const el = doc.getElementById("fabric-samples-data");
      if (!el) return;

      const masterData = JSON.parse(el.textContent);

      if (masterData.pagination.totalPages > 1) {
        const pageFetches = [];
        for (let page = 2; page <= masterData.pagination.totalPages; page++) {
          const pageUrl = new URL(url.toString());
          pageUrl.searchParams.set("page", page);
          pageFetches.push(
            fetchSectionDoc(pageUrl).then((pageDoc) => {
              const pageEl = pageDoc.getElementById("fabric-samples-data");
              return pageEl ? JSON.parse(pageEl.textContent).products : [];
            }),
          );
        }
        const pageResults = await Promise.all(pageFetches);
        pageResults.forEach((products) => masterData.products.push(...products));
      }

      allProducts = masterData.products;
      if (_onMasterReady) _onMasterReady();
    } catch (e) {
      // Stay in server mode if background fetch fails
    }
  }

  function onMasterReady(cb) {
    if (allProducts) {
      cb();
    } else {
      _onMasterReady = cb;
    }
  }

  function applyFilters(checkedFilters, sortBy) {
    if (!allProducts) return false;

    const hasFilters = Object.keys(checkedFilters).length > 0;
    data.hasActiveFilters = hasFilters;
    data.products = hasFilters
      ? allProducts.filter((product) =>
          Object.entries(checkedFilters).every(([type, values]) => {
            const pv = getProductFilterValues(product, type);
            return type === "features"
              ? values.every((v) => pv.includes(v))
              : values.some((v) => pv.includes(v));
          }))
      : allProducts;

    activeSort = sortBy || activeSort;
    buildMaps();
    groupProductsByBlock();
    renderGrid();
    buildFabricSamplesData();
    return true;
  }

  function getProductFilterValues(product, type) {
    switch (type) {
      case "colors": return product.colors || [];
      case "materials": return product.materials || [];
      case "features": return (product.features || []).map((f) => f.name);
      case "pricing": return product.pricing || [];
      case "names": return product.fabricNames || [];
      default: return [];
    }
  }

  function isReady() {
    return allProducts !== null;
  }

  function buildMaps() {
    productMap = new Map();
    productIdMap = new Map();
    data.products.forEach((p) => {
      productMap.set(p.variantId, p);
      productIdMap.set(p.id, p);
    });
  }

  function groupProductsByBlock() {
    blockProductMap = new Map();

    data.blocks.forEach((block) => {
      const title = block.title;
      let products;

      if (title === "Most Popular") {
        if (data.hasActiveFilters) {
          products = [];
        } else {
          products = data.products
            .filter((p) => p.mostPopular)
            .slice(0, data.mostPopularQty);
        }
      } else {
        products = data.products.filter(
          (p) => p.fabricNames && p.fabricNames.includes(title),
        );
      }

      const sortedProducts = sortProducts(products, activeSort);

      if (sortedProducts.length > 0) {
        const inStock = sortedProducts.filter((p) => !p.outOfStock);
        const outOfStock = sortedProducts.filter((p) => p.outOfStock);
        blockProductMap.set(block.id, {
          block,
          products: [...inStock, ...outOfStock],
        });
      }
    });
  }

  function renderGrid() {
    const container = document.querySelector(
      ".content-container__subcategories",
    );
    if (!container) return;

    if (blockProductMap.size === 0) {
      container.innerHTML =
        '<div id="main-collection-product-grid" class="collection collection--empty grid__wrapper"><span class="rte span-8 push-2 auto">No products found matching your filters.</span></div>';
      return;
    }

    let html = "";
    blockProductMap.forEach(({ block, products }) => {
      html += renderSubcategory(block, products);
    });
    container.innerHTML = html;
  }

  function renderSubcategory(block, products) {
    const isMostPopular = block.title === "Most Popular";

    const featuresHtml =
      !block.isFirst && block.features.length > 0
        ? `<div class="fabric-samples-types">${renderFeatureIcons(block.features)}</div>`
        : "";

    const typesWrapClass =
      !block.isFirst && block.features.length > 0
        ? "fabric-samples-types-wrap"
        : "";

    const cardsHtml = products
      .map((p) => renderCard(p, block.id, block.index, isMostPopular))
      .join("");

    return `<div class="subcategory-container fabric-samples-subcategory">
      <div class="subcategory-container__heading fabric-samples-heading">
        ${
          block.title
            ? `<div class="heading__title-block fabric-samples-title ${typesWrapClass}">
            <div class="heading__title">
              <span class="fabric-samples-title-content">${escapeHtml(block.title)}</span>
              ${!block.isFirst ? '<span class="desktop-hide fabric-samples-info-icon"></span>' : ""}
            </div>
            <div class="fabric-samples-line-container">
              ${!block.isFirst ? featuresHtml : ""}
              <span class="fabric-samples-line"></span>
            </div>
          </div>`
            : ""
        }
        <div class="heading__subtitle fabric-samples-subtitle">
          ${block.description ? `<span class="fabric-samples-subtitle-content">${block.description}</span>` : ""}
        </div>
      </div>
      <div class="subcategory-container__product-card-container fabric-samples-card-container"
           data-block="${block.id}" data-addon-type="Fabric">
        ${cardsHtml}
      </div>
    </div>`;
  }

  function renderCard(product, blockId, collectionIndex, isMostPopular) {
    const isOutOfStock = product.outOfStock;

    const cardClasses = [
      "product-card-container__product-card",
      "fabric-samples-card",
      "enavi_addon",
      isMostPopular ? "most-popular-card" : "",
      isOutOfStock ? "out-of-stock" : "",
    ]
      .filter(Boolean)
      .join(" ");

    let atcHtml;
    if (isOutOfStock) {
      atcHtml = `<button type="button" class="product-card__atc-btn fabric-samples-atc disabled" aria-label="Out of stock - ${escapeAttr(product.title)}" disabled>
        <span class="atc-btn__add">Out Of Stock</span>
        <span class="atc-btn__remove">${ICONS.check} Added to cart</span>
      </button>`;
    } else {
      atcHtml = `<button type="button" class="product-card__atc-btn fabric-samples-atc" aria-label="Add ${escapeAttr(product.title)} to cart">
        <span class="atc-btn__add">${ICONS.plus} Add to cart</span>
        <span class="atc-btn__remove">${ICONS.check} Added to cart</span>
      </button>`;
    }

    const wrapperAttrs =
      isMostPopular && isOutOfStock
        ? ""
        : `data-fancybox-trigger data-product-id-trigger="${product.id}" data-block-id="${blockId}" data-collection-index="${collectionIndex}"`;

    return `<div class="${cardClasses}"
         role="button" tabindex="0"
         aria-label="${escapeAttr(product.title)}"
         data-product-id="${product.variantId}"
         data-variant-id="${product.variantId}"
         data-fabric-colors="${(product.colors || []).join(",")}"
         data-fabric-materials="${(product.materials || []).join(",")}"
         data-fabric-features="${(product.features || []).map((f) => f.name).join(",")}"
         data-fabric-pricing="${(product.pricing || []).join(",")}"
         data-fabric-names="${(product.fabricNames || []).join(",")}"
         data-out-of-stock="${isOutOfStock}"
         data-cylindo-value="${product.title.split(" ").join("-")}"
         data-product-label="${escapeAttr(product.title)}"
         data-product-price="${product.price}">
      <div class="product-card__image-wrapper fabric-samples-wrapper" ${wrapperAttrs}>
        <img class="fabric-samples-image"
             width="200" height="200"
             src="${product.image360}"
             alt="${escapeAttr(product.imageAlt || product.title)}"
             loading="lazy" />
        <span class="product-card__more-details fabric-samples-more-details">
          ${ICONS.maximize}
          More details
        </span>
        <span class="product-card__title fabric-samples-card-title">${escapeHtml(product.title)}</span>
        ${atcHtml}
      </div>
    </div>`;
  }

  function buildDetailModal(productId, blockId) {
    const product = productIdMap.get(productId);
    if (!product) return null;

    const blockData = blockProductMap.get(blockId);
    if (!blockData) return null;

    const { products } = blockData;
    const items = products.map((p) => ({
      src: buildModalHtml(p, products, blockId),
      type: "html",
    }));

    const startIndex = products.findIndex((p) => p.id === productId);
    return { items, startIndex: Math.max(0, startIndex) };
  }

  function buildSingleModalHtml(productId, blockId) {
    const product = productIdMap.get(productId);
    if (!product) return null;

    const blockData = blockProductMap.get(blockId);
    if (!blockData) return null;

    return buildNativeModalHtml(product, blockData.products, blockId);
  }

  function getBlockProducts(blockId) {
    const blockData = blockProductMap.get(blockId);
    return blockData ? blockData.products : [];
  }

  function buildModalHtml(product, allProducts, blockId) {
    const isOutOfStock = product.outOfStock;
    const fabricName = (product.fabricNames || [])[0] || "";
    const productFeatures = product.features || [];

    const atcBtnHtml = isOutOfStock
      ? `<span class="atc-button__add">Out Of Stock</span>
         <span class="atc-button__remove">${ICONS.check} Added to cart</span>`
      : `<span class="atc-button__add">${ICONS.plus} Add to cart</span>
         <span class="atc-button__remove">${ICONS.check} Added to cart</span>`;

    const slidesHtml = buildSwiperSlides(allProducts, product.id, blockId);

    return `<div class="fabric-samples-details">
      <div class="fabric-samples-details-header">
        <span>${escapeHtml(product.title)}</span>
      </div>
      <div class="product-card-container__product-details fabric-samples-details-content">
        <div class="product-details__image-wrapper fabric-samples-details-left">
          <div class="fabric-samples-types fabric-samples-types-popup desktop-hide">
            ${renderFeatureIcons(productFeatures)}
          </div>
          <div class="fabric-samples-image-container">
            <img src="${product.imageLarge}"
                 alt="${escapeAttr(product.imageAlt || product.title)}"
                 width="${product.imageWidth}" height="${product.imageHeight}" />
            <button type="button" class="fabric-samples-zoom-icon" aria-label="Toggle zoom">${ICONS.zoom}</button>
          </div>
          <div class="pinch-zoom-container desktop-hide">
            tap &amp; pan to zoom
          </div>
          <div class="fabric-samples-details-navigation-text">
            Other colors in the ${escapeHtml(fabricName)} collection:
          </div>
          <div class="fabric-samples-details-navigation">
            <button class="prev-btn fabric-samples-details-previous">${ICONS.lessThan}</button>
            <div class="fabric-samples-details-slider swiper">
              <div class="swiper-wrapper" data-product="${product.id}">
                ${slidesHtml}
              </div>
            </div>
            <button class="next-btn fabric-samples-details-next">${ICONS.greaterThan}</button>
          </div>
          <span class="swiper-pagination"></span>
          <div class="product-details__description fabric-samples-description-container desktop-hide">
            <p class="fabric-samples-description-header">Extra features:</p>
            <div class="fabric-samples-description-content">${product.description || ""}</div>
          </div>
        </div>
        <div class="product-details__content-wrapper fabric-samples-details-right">
          <div class="content-wrapper__info">
            <div class="fabric-samples-types fabric-samples-types-popup mobile-hide">
              ${renderFeatureIcons(productFeatures)}
            </div>
            <div class="product-details__description fabric-samples-description-container mobile-hide">
              <p class="fabric-samples-description-header">Extra features:</p>
              <div class="fabric-samples-description-content">${product.description || ""}</div>
            </div>
          </div>
          <div class="quick-buy__buttons fabric-samples-buy-buttons"
               data-product-id="${product.variantId}">
            <button class="mobile-cancel-button desktop-hide" onclick="Fancybox.getInstance().close();">Cancel</button>
            <button class="atc-button fabric-samples-buy-atc mobile-atc-button">${atcBtnHtml}</button>
          </div>
        </div>
      </div>
    </div>`;
  }

  function buildSwiperSlides(products, currentProductId, blockId) {
    const isMobile = window.innerWidth < 980;
    let html = "";
    let slideIndex = 0;

    products.forEach((product, index) => {
      if (!isMobile && index % 10 === 0) {
        if (index !== 0) html += "</div>";
        const customClass =
          products.length < 6 ? " swiper-slide-custom" : "";
        html += `<div class="swiper-slide swiper-slide-row${customClass}" data-navigation-index="${slideIndex}">`;
        slideIndex++;
      }

      if (isMobile) {
        html += `<div class="swiper-slide swiper-slide-row" data-navigation-index="${index}">`;
      }

      const selectedClass =
        product.id === currentProductId ? "selected-navigation-image" : "";
      html += `<div class="sample-navigation-image ${selectedClass}" role="button" tabindex="0" aria-label="${escapeAttr(product.title)}" onclick="Fancybox.getInstance().jumpTo(${index}, { parentBlockId: '${blockId}' })" onkeydown="if(event.key==='Enter'||event.key===' '){event.preventDefault();Fancybox.getInstance().jumpTo(${index}, { parentBlockId: '${blockId}' })}">
        <img src="${product.imageNav}" alt="${escapeAttr(product.title)}" loading="lazy">
      </div>`;

      if (isMobile || index === products.length - 1) {
        html += "</div>";
      }
    });

    return html;
  }

  function buildNativeModalHtml(product, allProducts, blockId) {
    const isOutOfStock = product.outOfStock;
    const fabricName = (product.fabricNames || [])[0] || "";
    const productFeatures = product.features || [];

    const atcBtnHtml = isOutOfStock
      ? `<span class="atc-button__add">Out Of Stock</span>
         <span class="atc-button__remove">${ICONS.check} Added to cart</span>`
      : `<span class="atc-button__add">${ICONS.plus} Add to cart</span>
         <span class="atc-button__remove">${ICONS.check} Added to cart</span>`;

    const slidesHtml = buildNativeSwiperSlides(allProducts, product.id, blockId);

    return `<div class="fabric-samples-details">
      <div class="product-card-container__product-details fabric-samples-details-content">
        <div class="product-details__image-wrapper fabric-samples-details-left">
          <div class="fabric-samples-types fabric-samples-types-popup desktop-hide">
            ${renderFeatureIcons(productFeatures)}
          </div>
          <div class="fabric-samples-image-container">
            <img src="${product.imageLarge}"
                 alt="${escapeAttr(product.imageAlt || product.title)}"
                 width="${product.imageWidth}" height="${product.imageHeight}" />
            <button type="button" class="fabric-samples-zoom-icon" aria-label="Toggle zoom">${ICONS.zoom}</button>
          </div>
          <div class="pinch-zoom-container desktop-hide">
            tap &amp; pan to zoom
          </div>
          <div class="fabric-samples-details-navigation-text">
            Other colors in the ${escapeHtml(fabricName)} collection:
          </div>
          <div class="fabric-samples-details-navigation">
            <button class="prev-btn fabric-samples-details-previous">${ICONS.lessThan}</button>
            <div class="fabric-samples-details-slider swiper">
              <div class="swiper-wrapper" data-product="${product.id}">
                ${slidesHtml}
              </div>
            </div>
            <button class="next-btn fabric-samples-details-next">${ICONS.greaterThan}</button>
          </div>
          <span class="swiper-pagination"></span>
          <div class="product-details__description fabric-samples-description-container desktop-hide">
            <p class="fabric-samples-description-header">Extra features:</p>
            <div class="fabric-samples-description-content">${product.description || ""}
              <p class="fabric-samples-description-header fabric-samples-description-header--mt">More details:</p>
              <ul><li>Free of PFAS/PFOS &amp; other unwanted &quot;forever&quot; chemicals. Colors may differ in appearance on your screen due to monitor variations. Dye lots may vary.</li></ul>
            </div>
          </div>
        </div>
        <div class="product-details__content-wrapper fabric-samples-details-right">
          <div class="content-wrapper__info">
            <div class="fabric-samples-types fabric-samples-types-popup mobile-hide">
              ${renderFeatureIcons(productFeatures)}
            </div>
            <div class="product-details__description fabric-samples-description-container mobile-hide">
              <p class="fabric-samples-description-header">Extra features:</p>
              <div class="fabric-samples-description-content">${product.description || ""}
                <p class="fabric-samples-description-header fabric-samples-description-header--mt">More details:</p>
                <ul><li>Free of PFAS/PFOS &amp; other unwanted &quot;forever&quot; chemicals. Colors may differ in appearance on your screen due to monitor variations. Dye lots may vary.</li></ul>              </div>
            </div>
          </div>
          <div class="quick-buy__buttons fabric-samples-buy-buttons"
               data-product-id="${product.variantId}">
            <button class="mobile-cancel-button desktop-hide" data-modal-cancel>Cancel</button>
            <button class="atc-button fabric-samples-buy-atc mobile-atc-button">${atcBtnHtml}</button>
          </div>
        </div>
      </div>
    </div>`;
  }

  function buildNativeSwiperSlides(products, currentProductId, blockId) {
    const isMobile = window.innerWidth < 980;
    let html = "";
    let slideIndex = 0;

    if (isMobile) {
      products.forEach((product) => {
        const selectedClass =
          product.id === currentProductId ? "selected-navigation-image" : "";
        html += `<div class="sample-navigation-image ${selectedClass}" role="button" tabindex="0" aria-label="${escapeAttr(product.title)}" data-switch-product-id="${product.id}" data-switch-block-id="${blockId}">
          <img src="${product.imageNav}" alt="${escapeAttr(product.title)}" loading="lazy">
        </div>`;
      });
    } else {
      products.forEach((product, index) => {
        if (index % 10 === 0) {
          if (index !== 0) html += "</div>";
          const customClass =
            products.length < 6 ? " swiper-slide-custom" : "";
          html += `<div class="swiper-slide swiper-slide-row${customClass}" data-navigation-index="${slideIndex}">`;
          slideIndex++;
        }

        const selectedClass =
          product.id === currentProductId ? "selected-navigation-image" : "";
        html += `<div class="sample-navigation-image ${selectedClass}" role="button" tabindex="0" aria-label="${escapeAttr(product.title)}" data-switch-product-id="${product.id}" data-switch-block-id="${blockId}">
          <img src="${product.imageNav}" alt="${escapeAttr(product.title)}" loading="lazy">
        </div>`;

        if (index === products.length - 1) {
          html += "</div>";
        }
      });
    }

    return html;
  }

  function buildFabricSamplesData() {
    window.fabricSamplesData = {};
    blockProductMap.forEach(({ block, products }) => {
      if (block.title === "Most Popular") return;
      window.fabricSamplesData[block.id] = products.map((p) => ({
        id: p.id,
        image: p.imageNav,
      }));
    });
  }

  function renderFeatureIcons(features) {
    if (!features || features.length === 0) return "";
    return features
      .map(
        (f) =>
          `<span class="feature-tooltip-container"><img src="${f.icon}" alt="${escapeHtml(f.name)}" width="24" height="24" loading="lazy"><span class="tooltip-text">${escapeHtml(f.name)}</span></span>`,
      )
      .join("");
  }

  function escapeHtml(str) {
    if (!str) return "";
    return String(str)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function escapeAttr(str) {
    if (!str) return "";
    return String(str)
      .replace(/&/g, "&amp;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;");
  }

  function getProductByVariantId(variantId) {
    return productMap.get(variantId);
  }

  function getProductById(id) {
    return productIdMap.get(id);
  }

  function getData() {
    return data;
  }

  function getBlockProductMap() {
    return blockProductMap;
  }

  function getAllProducts() {
    return allProducts;
  }

  return {
    init,
    initFromData,
    onFullLoad,
    applyFilters,
    isReady,
    getAllProducts,
    onMasterReady,
    buildDetailModal,
    buildSingleModalHtml,
    getBlockProducts,
    getProductByVariantId,
    getProductById,
    getData,
    getBlockProductMap,
    renderGrid,
    buildFabricSamplesData,
    renderFeatureIcons,
  };
})();
